module.exports = __webpack_public_path__ + "img/triangle.12f78c95.svg";